import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgPlugin = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 20,
	height: 20,
	fill: "none",
	viewBox: "0 0 20 20",
	ref,
	"aria-labelledby": titleId,
	...props,
	children: [title ? /* @__PURE__ */ _jsx("title", {
		id: titleId,
		children: title
	}) : null, /* @__PURE__ */ _jsx("path", {
		stroke: "currentColor",
		strokeLinecap: "round",
		strokeLinejoin: "round",
		strokeWidth: 1.5,
		d: "M10 15.25v3M7.75 1.75v3m4.5-3v3m-2.5 10.5h.5a6 6 0 0 0 6-6v-2.5a2 2 0 0 0-2-2h-8.5a2 2 0 0 0-2 2v2.5a6 6 0 0 0 6 6Z"
	})]
});
const ForwardRef = forwardRef(SvgPlugin);
export { ForwardRef as ReactComponent };
